import type { MutationClass, ToolingState, ToolState } from '../../../models'

export class SetStateMutation implements MutationClass {
  static execute(
    this: void,
    state: ToolingState,
    newState: { [tool: string]: Partial<ToolState> },
  ): void {
    Object.entries(newState).forEach(([tool, newToolState]) => {
      const toolState = state.tools[tool]
      state.tools = {
        ...state.tools,
        [tool]: { ...toolState, ...newToolState },
      }
    })
  }
}
